module.exports=function(n){var r=!String(n).split(".")[1];return 1==n&&r?"one":"other"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-format/locale/en/quantify.js
// module id = 618
// module chunks = 0